import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { CustomOutlinedDisabledTextField } from "../../../../../partials/content/Forms";
import { TabView, TabPanel } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Table } from "react-bootstrap";
import DeliveryPrintOut from "./deliveryPrintOut";
import { formatDate } from "../../../../../utils/utils";
import { Typography } from "@material-ui/core";
import Illustration from "../../../../../partials/content/Illustration";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { Editor } from "primereact/editor";
import { getSoDeliveryDetail } from "../../../../../services/sales/salesDeliveryService";
function DeliveryDetail({ deliveryID }) {
  const [deliveryOrder, setDeliveryOrder] = useState({
    customer: {
      customerName: "",
    },
    deliveryCost: 0,
    currency: {
      currencyCode: "",
    },
    resiNo: "",
    driverName: "",
    recipient: "",
    address: "",
    city: "",
    province: "",
    addressPhone: "",
    addressEmail: "",
    postalCode: "",
    countryName: "",
    delivery: {
      ID: 0,
      deliveryItem: [],
    },
    deliveryItem: [],
    deliveryService: [],
    deliveryServiceData: [],
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeIndex2, setActiveIndex2] = useState(0);
  const [itemsReturn, setItemsReturn] = useState([]);

  const itemsReturnDetailColumn = [
    {
      header: "Note",
      field: "note",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  useEffect(() => {
    getDeliveryDetailData(deliveryID);
  }, [deliveryID]);
  return (
    <React.Fragment>
      <div className="tabview">
        <div className="card">
          <TabView className="tabview" scrollable>
            <TabPanel header="Goods Issued Main" rightIcon="fas fa-th-large">
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <Card>
                        <Card.Header>
                          <i className="fas fa-window-maximize"></i>
                          <span>
                            <strong>Goods Issued Header</strong>
                          </span>
                        </Card.Header>
                        <Card.Body>
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <CustomOutlinedDisabledTextField
                                label="Customer Name"
                                value={deliveryOrder.customer.customerName}
                              />
                              <CustomOutlinedDisabledTextField
                                label="Delivery Date"
                                value={formatDate(deliveryOrder.deliveryDate)}
                              />
                              <CustomOutlinedDisabledTextField
                                label="Delivery Receipt No"
                                value={deliveryOrder.resiNo}
                              />
                              <CustomOutlinedDisabledTextField
                                label="Delivery Team"
                                value={deliveryOrder.driverName}
                              />
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <Card>
                        <Card.Header>
                          <i className="fas fa-map-marked-alt"></i>
                          <span>
                            <strong>Shipping Address</strong>
                          </span>
                        </Card.Header>
                        <Card.Body>
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <CustomOutlinedDisabledTextField
                                label="Ship To"
                                value={deliveryOrder.recipient}
                              />
                              <div className="row">
                                <div className="col-sm-6 col-md-6 col-lg-6">
                                  <CustomOutlinedDisabledTextField
                                    label="Address"
                                    value={deliveryOrder.address}
                                  />
                                  <CustomOutlinedDisabledTextField
                                    label="City"
                                    value={deliveryOrder.city}
                                  />
                                  <CustomOutlinedDisabledTextField
                                    label="Province / State"
                                    value={deliveryOrder.province}
                                  />
                                </div>
                                <div className="col-sm-6 col-md-6 col-lg-6">
                                  <CustomOutlinedDisabledTextField
                                    label="Phone Number"
                                    value={deliveryOrder.addressPhone}
                                  />
                                  <CustomOutlinedDisabledTextField
                                    label="Email"
                                    value={deliveryOrder.addressEmail}
                                  />
                                  <CustomOutlinedDisabledTextField
                                    label="Postal Code"
                                    value={deliveryOrder.postalCode}
                                  />
                                </div>
                              </div>
                              <CustomOutlinedDisabledTextField
                                label="Country"
                                value={deliveryOrder.countryName}
                              />
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion">
                <div className="card">
                  <Accordion
                    className="accordion"
                    activeIndex={activeIndex}
                    onTabChange={(e) => setActiveIndex(e.index)}
                  >
                    <AccordionTab
                      header={
                        <React.Fragment>
                          <i className="fas fa-sitemap"></i>
                          <span>
                            <strong>Delivery Items</strong>
                          </span>
                        </React.Fragment>
                      }
                    >
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="tabview">
                            <div className="card">
                              <TabView
                                className="tabview"
                                scrollable
                                activeIndex={activeIndex2}
                                onTabChange={(e) => setActiveIndex2(e.index)}
                              >
                                {deliveryOrder.deliveryItem &&
                                deliveryOrder.deliveryItem.length > 0 ? (
                                  <TabPanel
                                    header="Delivery Order Items"
                                    rightIcon="fas fa-boxes"
                                  >
                                    <div className="row">
                                      <div className="col-sm-12 col-md-12 col-lg-12">
                                        <div className="card">
                                          <Table
                                            striped
                                            borderless
                                            size="sm"
                                            responsive="xl"
                                          >
                                            {deliveryOrder.deliveryItem &&
                                            deliveryOrder.deliveryItem.length >
                                              0 ? (
                                              <thead>
                                                <tr>
                                                  <th style={{ width: "50%" }}>
                                                    <Typography className="mx-1 kt-font-bolder">
                                                      Item Name
                                                    </Typography>
                                                  </th>
                                                  <th style={{ width: "15%" }}>
                                                    <Typography className="mx-1 kt-font-bolder">
                                                      Quantity
                                                    </Typography>
                                                  </th>
                                                  <th style={{ width: "15%" }}>
                                                    <Typography className="mx-1 kt-font-bolder">
                                                      Unit
                                                    </Typography>
                                                  </th>
                                                </tr>
                                              </thead>
                                            ) : null}
                                            <tbody>
                                              {deliveryOrder.deliveryItem &&
                                              deliveryOrder.deliveryItem
                                                .length > 0 ? (
                                                deliveryOrder.deliveryItem.map(
                                                  (item, index) => {
                                                    return (
                                                      <tr
                                                        key={index}
                                                        className="border-top"
                                                      >
                                                        <td>
                                                          <Typography className="mx-1 my-1">
                                                            {item.itemType >
                                                            0 ? (
                                                              <span>
                                                                <BootstrapTooltip
                                                                  title={
                                                                    item.itemTypeName
                                                                  }
                                                                >
                                                                  <span className="mr-2">
                                                                    <i
                                                                      className={
                                                                        item.itemType ===
                                                                        1
                                                                          ? "fas fa-boxes text-success"
                                                                          : item.itemType ===
                                                                            2
                                                                          ? "fas fa-tools text-primary"
                                                                          : item.itemType ===
                                                                            3
                                                                          ? "fas fa-building text-info"
                                                                          : item.itemType ===
                                                                            4
                                                                          ? "fas fa-boxes text-warning"
                                                                          : item.itemType ===
                                                                            5
                                                                          ? "fas fa-boxes text-danger"
                                                                          : null
                                                                      }
                                                                    ></i>
                                                                  </span>
                                                                </BootstrapTooltip>
                                                                <span>
                                                                  {
                                                                    item.itemCode
                                                                  }{" "}
                                                                  {
                                                                    item.itemName
                                                                  }
                                                                </span>
                                                              </span>
                                                            ) : (
                                                              <React.Fragment>
                                                                {item.itemCode}{" "}
                                                                {item.itemName}
                                                              </React.Fragment>
                                                            )}
                                                          </Typography>
                                                        </td>
                                                        <td>
                                                          <Typography className="mx-1 my-1">
                                                            {item.qty}
                                                          </Typography>
                                                        </td>
                                                        <td>
                                                          <Typography className="mx-1 my-1">
                                                            {item.uom.uomName}
                                                          </Typography>
                                                        </td>
                                                      </tr>
                                                    );
                                                  }
                                                )
                                              ) : (
                                                <tr>
                                                  <td
                                                    className="text-center py-3"
                                                    colSpan="4"
                                                  >
                                                    <Illustration
                                                      imageSource="INVIFO Sales.png"
                                                      guidance="You don't have any Delivered items yet"
                                                      guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                                      size="sm"
                                                    ></Illustration>
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </Table>
                                        </div>
                                      </div>
                                    </div>
                                  </TabPanel>
                                ) : (
                                  <TabPanel
                                    header="Delivery Order Item"
                                    rightIcon="fas fa-boxes"
                                    disabled
                                  ></TabPanel>
                                )}
                                {deliveryOrder.delivery.deliveryItem &&
                                deliveryOrder.delivery.deliveryItem.length >
                                  0 ? (
                                  <TabPanel
                                    header="Items Delivered"
                                    rightIcon="fas fa-boxes"
                                  >
                                    <div className="row">
                                      <div className="col-sm-12 col-md-12 col-lg-12">
                                        <div className="card">
                                          <Table
                                            striped
                                            borderless
                                            size="sm"
                                            responsive="xl"
                                          >
                                            {deliveryOrder.delivery
                                              .deliveryItem &&
                                            deliveryOrder.delivery.deliveryItem
                                              .length > 0 ? (
                                              <thead>
                                                <tr>
                                                  <th style={{ width: "50%" }}>
                                                    <Typography className="mx-1 kt-font-bolder">
                                                      Item Name
                                                    </Typography>
                                                  </th>
                                                  <th style={{ width: "15%" }}>
                                                    <Typography className="mx-1 kt-font-bolder">
                                                      Quantity
                                                    </Typography>
                                                  </th>
                                                  <th style={{ width: "15%" }}>
                                                    <Typography className="mx-1 kt-font-bolder">
                                                      Unit
                                                    </Typography>
                                                  </th>
                                                  <th style={{ width: "20%" }}>
                                                    <Typography className="mx-1 kt-font-bolder">
                                                      Batch ID
                                                    </Typography>
                                                  </th>
                                                </tr>
                                              </thead>
                                            ) : null}
                                            <tbody>
                                              {deliveryOrder.delivery
                                                .deliveryItem &&
                                              deliveryOrder.delivery
                                                .deliveryItem.length > 0 ? (
                                                deliveryOrder.delivery.deliveryItem.map(
                                                  (item, index) => {
                                                    return (
                                                      <tr
                                                        key={index}
                                                        className="border-top"
                                                      >
                                                        <td>
                                                          <Typography className="mx-1 my-1">
                                                            {item.itemType >
                                                            0 ? (
                                                              <span>
                                                                <BootstrapTooltip
                                                                  title={
                                                                    item.itemTypeName
                                                                  }
                                                                >
                                                                  <span className="mr-2">
                                                                    <i
                                                                      className={
                                                                        item.itemType ===
                                                                        1
                                                                          ? "fas fa-boxes text-success"
                                                                          : item.itemType ===
                                                                            2
                                                                          ? "fas fa-tools text-primary"
                                                                          : item.itemType ===
                                                                            3
                                                                          ? "fas fa-building text-info"
                                                                          : item.itemType ===
                                                                            4
                                                                          ? "fas fa-boxes text-warning"
                                                                          : item.itemType ===
                                                                            5
                                                                          ? "fas fa-boxes text-danger"
                                                                          : null
                                                                      }
                                                                    ></i>
                                                                  </span>
                                                                </BootstrapTooltip>
                                                                <span>
                                                                  {
                                                                    item.itemCode
                                                                  }{" "}
                                                                  {
                                                                    item.itemName
                                                                  }
                                                                </span>
                                                              </span>
                                                            ) : (
                                                              <React.Fragment>
                                                                {item.itemCode}{" "}
                                                                {item.itemName}
                                                              </React.Fragment>
                                                            )}
                                                          </Typography>
                                                        </td>
                                                        <td>
                                                          <Typography className="mx-1 my-1">
                                                            {item.qty}
                                                          </Typography>
                                                        </td>
                                                        <td>
                                                          <Typography className="mx-1 my-1">
                                                            {item.uom.uomName}
                                                          </Typography>
                                                        </td>
                                                        <td>
                                                          <Typography className="mx-1 my-1">
                                                            {item.batchID}
                                                          </Typography>
                                                        </td>
                                                      </tr>
                                                    );
                                                  }
                                                )
                                              ) : (
                                                <tr>
                                                  <td
                                                    className="text-center py-3"
                                                    colSpan="4"
                                                  >
                                                    <Illustration
                                                      imageSource="INVIFO Sales.png"
                                                      guidance="You don't have any Delivered items yet"
                                                      guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                                      size="sm"
                                                    ></Illustration>
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </Table>
                                        </div>
                                      </div>
                                    </div>
                                  </TabPanel>
                                ) : (
                                  <TabPanel
                                    header="Items Delivered"
                                    rightIcon="fas fa-boxes"
                                    disabled
                                  ></TabPanel>
                                )}
                                {deliveryOrder.deliveryService &&
                                deliveryOrder.deliveryService.length > 0 ? (
                                  <TabPanel
                                    header="Services Delivered"
                                    rightIcon="fas fa-tools"
                                  >
                                    <div className="row">
                                      <div className="col-sm-12 col-md-12 col-lg-12">
                                        <div className="card">
                                          <Table
                                            striped
                                            borderless
                                            size="sm"
                                            responsive="xl"
                                          >
                                            {deliveryOrder.deliveryService &&
                                            deliveryOrder.deliveryService
                                              .length > 0 ? (
                                              <thead>
                                                <tr>
                                                  <th style={{ width: "50%" }}>
                                                    <Typography className="mx-1 kt-font-bolder">
                                                      Service Name
                                                    </Typography>
                                                  </th>
                                                  <th style={{ width: "25%" }}>
                                                    <Typography className="mx-1 kt-font-bolder">
                                                      Quantity
                                                    </Typography>
                                                  </th>
                                                  <th style={{ width: "25%" }}>
                                                    <Typography className="mx-1 kt-font-bolder">
                                                      Unit
                                                    </Typography>
                                                  </th>
                                                </tr>
                                              </thead>
                                            ) : null}
                                            <tbody>
                                              {deliveryOrder.deliveryService &&
                                              deliveryOrder.deliveryService
                                                .length > 0 ? (
                                                deliveryOrder.deliveryService.map(
                                                  (service, index) => {
                                                    return (
                                                      <tr
                                                        key={index}
                                                        className="border-top"
                                                      >
                                                        <td>
                                                          <Typography className="mx-1 my-1">
                                                            {service.itemType >
                                                            0 ? (
                                                              <span>
                                                                <BootstrapTooltip
                                                                  title={
                                                                    service.itemTypeName
                                                                  }
                                                                >
                                                                  <span className="mr-2">
                                                                    <i
                                                                      className={
                                                                        service.itemType ===
                                                                        1
                                                                          ? "fas fa-boxes text-success"
                                                                          : service.itemType ===
                                                                            2
                                                                          ? "fas fa-tools text-primary"
                                                                          : service.itemType ===
                                                                            3
                                                                          ? "fas fa-building text-info"
                                                                          : service.itemType ===
                                                                            4
                                                                          ? "fas fa-boxes text-warning"
                                                                          : service.itemType ===
                                                                            5
                                                                          ? "fas fa-boxes text-danger"
                                                                          : null
                                                                      }
                                                                    ></i>
                                                                  </span>
                                                                </BootstrapTooltip>
                                                                <span>
                                                                  {
                                                                    service.serviceCode
                                                                  }{" "}
                                                                  {
                                                                    service.serviceName
                                                                  }
                                                                </span>
                                                              </span>
                                                            ) : (
                                                              <React.Fragment>
                                                                {
                                                                  service.serviceCode
                                                                }{" "}
                                                                {
                                                                  service.serviceName
                                                                }
                                                              </React.Fragment>
                                                            )}
                                                          </Typography>
                                                        </td>
                                                        <td>
                                                          <Typography className="mx-1 my-1">
                                                            {service.qty}
                                                          </Typography>
                                                        </td>
                                                        <td>
                                                          <Typography className="mx-1 my-1">
                                                            {
                                                              service.uom
                                                                .uomName
                                                            }
                                                          </Typography>
                                                        </td>
                                                      </tr>
                                                    );
                                                  }
                                                )
                                              ) : (
                                                <tr>
                                                  <td
                                                    className="text-center py-3"
                                                    colSpan="3"
                                                  >
                                                    <Illustration
                                                      imageSource="INVIFO Sales.png"
                                                      guidance="You don't have any Delivered service items yet"
                                                      guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                                      size="sm"
                                                    ></Illustration>
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </Table>
                                        </div>
                                      </div>
                                    </div>
                                  </TabPanel>
                                ) : (
                                  <TabPanel
                                    header="Services Delivered"
                                    rightIcon="fas fa-tools"
                                    disabled
                                  ></TabPanel>
                                )}
                              </TabView>
                            </div>
                          </div>
                        </div>
                      </div>
                    </AccordionTab>
                  </Accordion>
                </div>
              </div>
            </TabPanel>
            <TabPanel header={"Note"} rightIcon="fas fa-sticky-note">
              <Editor
                style={{ height: "200px", width: "100%" }}
                value={deliveryOrder.note}
                placeholder="Type your notes here..."
                readOnly={true}
                className="editor-grey"
              />
            </TabPanel>
            {/*
            <TabPanel header="Items Return" rightIcon="fas fa-box">
              {itemsReturn.length ? (
                <React.Fragment>
                  <CustomDataTable
                    data={itemsReturn}
                    dataDetailColumns={itemsReturnDetailColumn}
                    onRefreshData={() => {
                      getDeliveryDetailData(deliveryID);
                    }}
                    columns={[
                      {
                        header: "Item Type",
                        field: "itemTypeName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.itemTypeName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                        hidden: true,
                      },
                      {
                        header: "Item Code",
                        field: "itemCode",
                        body: (rowData) => (
                          <React.Fragment>
                            {rowData.itemType > 0 ? (
                              <span>
                                <BootstrapTooltip title={rowData.itemTypeName}>
                                  <span className="mr-2">
                                    <i
                                      className={
                                        rowData.itemType === 1
                                          ? "fas fa-boxes text-success"
                                          : rowData.itemType === 2
                                          ? "fas fa-tools text-primary"
                                          : rowData.itemType === 3
                                          ? "fas fa-building text-info"
                                          : rowData.itemType === 4
                                          ? "fas fa-boxes text-warning"
                                          : rowData.itemType === 5
                                          ? "fas fa-boxes text-danger"
                                          : null
                                      }
                                    ></i>
                                  </span>
                                </BootstrapTooltip>
                                <span>
                                  <ResponsiveEllipsis
                                    text={rowData.itemCode}
                                    maxLine="1"
                                    displayInline
                                  />
                                </span>
                              </span>
                            ) : (
                              <React.Fragment>
                                <ResponsiveEllipsis
                                  text={rowData.itemCode}
                                  maxLine="1"
                                />
                              </React.Fragment>
                            )}
                          </React.Fragment>
                        ),
                        sortable: true,
                      },
                      {
                        header: "Item Name",
                        field: "itemName",
                        body: (rowData) => (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.itemName}
                              maxLine="1"
                            />
                          </React.Fragment>
                        ),
                        sortable: true,
                      },
                      {
                        header: "Returned Quantity",
                        field: "qtyReturn",
                        body: (rowData) => (
                          <div>
                            {rowData.qtyReturn} {rowData.uomName}
                          </div>
                        ),
                        sortable: true,
                      },
                      {
                        header: "Unit",
                        field: "uomName",
                        body: null,
                        sortable: true,
                        hidden: true,
                      },
                      {
                        header: "Batch ID",
                        field: "batchID",
                        body: null,
                        sortable: true,
                      },
                      {
                        header: "Reason",
                        field: "reasonName",
                        body: null,
                        sortable: true,
                      },
                    ]}
                  />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Illustration
                    imageSource="INVIFO Inventory.png"
                    guidance={`You don't have any Returned Items for this goods issued yet`}
                    guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                    size="md"
                  ></Illustration>
                </React.Fragment>
              )}
            </TabPanel>
  */}
            <TabPanel header="Print Out" rightIcon="fas fa-print">
              <DeliveryPrintOut delivery={deliveryOrder} />
            </TabPanel>
          </TabView>
        </div>
      </div>
    </React.Fragment>
  );
  async function getDeliveryDetailData(deliveryID) {
    const response = await getSoDeliveryDetail(deliveryID);
    const { data } = response.data;
    setDeliveryOrder(data.soDelivery);
    setItemsReturn(data.itemsReturn);
    if (data.soDelivery.deliveryItem.length === 0) {
      setActiveIndex2(1);
    }
  }
}

export default DeliveryDetail;
